/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import moment, { min } from "moment";

function getColor(color, alpha) {
    let _ = document.createElement('div');
    _.style.color = color;
    _.style.display = 'none';
    document.body.appendChild(_);
    const rgb = window.getComputedStyle(_).color.replace("rgb(", "").replace(")", "").split(", ");
    document.body.removeChild(_);
    return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
}

function trailing_earnings(row, splitFactor) {
    if (!row) return 0;

    return row["c_eps"]; // * splitFactor;

    // minSplitFactor = minSplitFactor || 1;

    // const q0 = row["q0"];
    // const q1 = row["q_1"];
    // const q2 = row["q_2"];
    // const q3 = row["q_3"];
    // const split_factor = row["price_1"] / minSplitFactor;
    // return (q0 + q1 + q2 + q3) / split_factor;
}
function one_year_forward_earnings(row, minSplitFactor) {
    if (!row) return 0;

    return row["c_besteps1"] * minSplitFactor;

    // minSplitFactor = minSplitFactor || 1;

    // const today_est_revision = row["today_est_revision"];
    // const split_factor = row["price_1"] / minSplitFactor;
    // const val = today_est_revision / split_factor;
    // return val == 0 ? null : val;
}
function two_year_forward_earnings(row, minSplitFactor) {
    if (!row) return 0;

    return row["c_besteps2"] * minSplitFactor;

    // minSplitFactor = minSplitFactor || 1;

    // const estimate_best_eps_lt = row["estimate_best_eps_lt"];
    // const split_factor = row["price_1"] / minSplitFactor;
    // const val = estimate_best_eps_lt / split_factor;
    // return val == 0 ? null : val;
}
function price(row, minSplitFactor) {
    if (!row) return 0;

    minSplitFactor = minSplitFactor || 1;

    const price = row["c_adjprice"] * minSplitFactor;
    //const split_factor = row["c_adjprice"] / minSplitFactor;
    const val = price; // / split_factor;
    return val == 0 ? null : val;
}
function dividend(row, splitFactor) {
    if (!row) return 0;

    // c_yield now maps to indicated dividend per share (already split-adjusted)
    return row["c_yield"]; // * splitFactor;

    // minSplitFactor = minSplitFactor || 1;

    // const _yield = row["yield"];
    // const split_factor = row["price_1"] / minSplitFactor;
    // const price2 = row["price_2"];
    // const val = _yield * price2 / split_factor;
    // return val == 0 ? null : val;
}

function net_debt(row) {
    if (!row) return 0;

    const cash = row["cash"];
    const debt = row["debt"];
    return debt - cash;
}
function net_debt_pos(row) {
    if (!row) return 0;

    // const val = net_debt(row);
    // if (val > 0) return val;
    // else return null;

    if (row.c_netdebt > 0) return row.c_netdebt;
    else return null;
}
function net_debt_neg(row) {
    if (!row) return 0;

    // const val = net_debt(row);
    // if (val <= 0) return Math.abs(val);
    // else return null;

    if (row.c_netdebt <= 0) return Math.abs(row.c_netdebt);
    else return null;
}
// Forward return based on look-forward months:
// fwd_return[t] = P[t+h] / P[t] - 1
function forward_return(row, arr, lookForwardMonths = 12) {
    if (!row || !Array.isArray(arr) || arr.length === 0) return null;

    const index = arr.indexOf(row);
    if (index === -1) return null;

    const offset = Number(lookForwardMonths);
    if (!Number.isFinite(offset) || offset <= 0) return null;

    const futureIndex = index + offset;
    if (futureIndex >= arr.length) return null;

    const priceNow = arr[index]?.c_adjprice;
    const priceFuture = arr[futureIndex]?.c_adjprice;

    if (priceNow === null || priceNow === undefined || priceNow === 0) return null;
    if (priceFuture === null || priceFuture === undefined) return null;

    return (priceFuture / priceNow) - 1;
}
function average_price_behind(row, arr, months, minSplitFactor) {
    if (!row) return 0;
    if (!months) months = 12;
    const rowDate = moment(row["c_date"], "YYYY-MM-DD");
    const monthsAgo = rowDate.clone().subtract(months, "months");

    const filtered = arr.filter(d => monthsAgo <= moment(d["c_date"], "YYYY-MM-DD") && moment(d["c_date"], "YYYY-MM-DD") <= rowDate);
    const avg = filtered.reduce((acc, d) => acc + price(d, minSplitFactor), 0) / filtered.length;
    return avg;
}
function average_price_behind_series(arr, months, minSplitFactor) {
    if (!Array.isArray(arr) || arr.length === 0) return [];

    if (!months) months = 12;

    const parsedDates = arr.map((row) => moment(row["c_date"], "YYYY-MM-DD"));
    const prices = arr.map((row) => price(row, minSplitFactor));
    const series = [];

    let left = 0;
    let sum = 0;
    let count = 0;

    for (let i = 0; i < arr.length; i++) {
        const windowStart = parsedDates[i].clone().subtract(months, "months");

        while (left <= i && parsedDates[left].isBefore(windowStart)) {
            const leftPrice = prices[left];
            if (leftPrice !== null && leftPrice !== undefined) {
                sum -= leftPrice;
                count--;
            }
            left++;
        }

        const currentPrice = prices[i];
        if (currentPrice !== null && currentPrice !== undefined) {
            sum += currentPrice;
            count++;
        }

        series.push(count > 0 ? sum / count : null);
    }

    return series;
}
function average_price_ahead(row, arr, months) {
    if (!row) return 0;
    if (!months) months = 12;
    const rowDate = moment(row["c_date"], "YYYY-MM-DD");
    const monthsAhead = rowDate.clone().add(months, "months");

    const filtered = arr.filter(d => rowDate <= moment(d["c_date"], "YYYY-MM-DD") && moment(d["c_date"], "YYYY-MM-DD") <= monthsAhead);
    const avg = filtered.reduce((acc, d) => acc + price(d), 0) / filtered.length;
    return avg;
}
// METRIC ABSENT: abs_reversion (c_value_reversion) is no longer available in new schema
// Keeping function for label display, returns null
function abs_reversion(row) {
    if (!row) return null;
    // NOTE: c_value_reversion no longer available in new get_company_base_data schema
    return row.c_value_reversion ?? null;
}
// METRIC ABSENT: growth_reversion (c_peg_reversion) is no longer available in new schema
// Keeping function for label display, returns null
function growth_reversion(row) {
    if (!row) return null;
    // NOTE: c_peg_reversion no longer available in new get_company_base_data schema
    return row.c_peg_reversion ?? null;
}
function reversion(row) {
    if (!row) return 0;
    return row.c_bestfit_reversion;
}
function reversion_mean(row) {
    if (!row) return null;
    return row.c_reversion_mean ?? null;
}
function reversion_slope(row) {
    if (!row) return null;
    return row.c_reversion_slope_annualized ?? null;
}
// METRIC ABSENT: confidence (c_bestfit_score) is no longer available in new schema
// Keeping function for label display, returns null
function confidence(row) {
    if (!row) return null;
    // NOTE: c_bestfit_score no longer available in new get_company_base_data schema
    return row.c_bestfit_score ?? null;
}

// METRIC ABSENT: pe_reversion (c_index_reversion) is no longer available in new schema
// Keeping function for label display, returns null
function pe_reversion(row) {
    if (!row) return null;
    // NOTE: c_index_reversion no longer available in new get_company_base_data schema
    return row.c_index_reversion ?? null;
}
// function ps_reversion(row) {
//     if (!row) return 0;

//     const sales = row["price_by_sales"];
//     const median_sales = row["median_of_price_by_sales"];
//     const val = (median_sales / sales) - 1
//     return val == 0 ? null : val;
// }

function total_return(row) {
    const val = row["b_tr"] || row["i_totalreturn"];
    return val == 0 ? null : val;
}

function change(n_1, n_0) {
    if (!n_0) n_0 = 1;
    return parseFloat((n_1 - n_0) / n_0);
}

export default {
    getColor,
    trailing_earnings,
    one_year_forward_earnings,
    two_year_forward_earnings,
    price,
    dividend,
    net_debt,
    net_debt_pos,
    net_debt_neg,
    forward_return,
    abs_reversion,
    growth_reversion,
    pe_reversion,
    //ps_reversion,
    total_return,
    average_price_behind,
    average_price_behind_series,
    average_price_ahead,
    change,
    reversion,
    reversion_mean,
    confidence,
    reversion_slope
}
